module.exports = __webpack_public_path__ + "static/media/token-qbt.c0db8d7a.svg";